import { ASSET_STUDIO } from '@/types/shared/navigation-tabs.enums';

export const getComponentDiagnostics = (data: any[], selectedComponent?: string) => {
  if (selectedComponent === ASSET_STUDIO.ALL_COMPONENTS) return data;
  return data?.map(([timestamp, { site_id, assets }]) => {
    const filteredAssets = assets?.map((asset: any) => ({
      ...asset,
      components: asset.components
        .map((component: any) => {
          if (selectedComponent && component.component_id !== selectedComponent) {
            return null;
          }

          return {
            ...component,
            diagnostics: component.diagnostics || [],
            // Backwards compatible: handle nested subcomponents if they exist
            subcomponents: component.subcomponents?.map((subcomponent: any) => ({
              ...subcomponent,
              diagnostics: subcomponent.diagnostics || [],
            })) || undefined,
          };
        })
        .filter(Boolean), // Remove null components if filtered out
    }));

    return [
      timestamp,
      {
        site_id,
        assets: filteredAssets,
      },
    ];
  });
};
